// client/src/modules/huddle/routes.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '../../components/ProtectedRoute';
import { lazyWithRetry } from '../../lib/lazyWithRetry';

const HuddleLanding = lazyWithRetry(() =>
  import('../../pages/Huddle/HuddleLanding').then((m) => ({ default: m.default }))
);
const MeetingsPage = lazyWithRetry(() =>
  import('../../pages/Huddle/Meetings/MeetingsPage').then((m) => ({ default: m.default }))
);
const TemplateEditor = lazyWithRetry(() =>
  import('../../pages/Huddle/Meetings/TemplateEditor').then((m) => ({ default: m.default }))
);
const MeetingInProgressPage = lazyWithRetry(() =>
  import('../../pages/Huddle/Meetings/MeetingInProgressPage').then((m) => ({ default: m.default }))
);
const MeetingHistoryDetail = lazyWithRetry(() =>
  import('../../pages/Huddle/Meetings/MeetingHistoryDetail').then((m) => ({ default: m.default }))
);
const ActionItemsPage = lazyWithRetry(() =>
  import('../../pages/Huddle/ActionItems/ActionItemsPage').then((m) => ({ default: m.default }))
);
const DecisionsPage = lazyWithRetry(() =>
  import('../../pages/Huddle/Decisions/DecisionsPage').then((m) => ({ default: m.default }))
);
const AnnouncementsPlaceholder = lazyWithRetry(() =>
  import('../../pages/Huddle/Announcements/AnnouncementsPlaceholder').then((m) => ({ default: m.default }))
);
const VtoPage = lazyWithRetry(() =>
  import('../../pages/Huddle/VTO/VtoPage').then((m) => ({ default: m.default }))
);
const AccountabilityPage = lazyWithRetry(() =>
  import('../../pages/Huddle/Accountability/AccountabilityPage').then((m) => ({ default: m.default }))
);

/**
 * Huddle module routes - relative to /huddle prefix.
 * Sub-plan 2 wires the meetings flow (list, edit, in-progress, history).
 * Other sub-plans replace each remaining placeholder.
 */
export const routes: RouteObject[] = [
  {
    index: true,
    element: <ProtectedRoute><HuddleLanding /></ProtectedRoute>,
  },
  {
    path: 'meetings',
    element: <ProtectedRoute><MeetingsPage /></ProtectedRoute>,
  },
  {
    path: 'meetings/templates/new',
    element: <ProtectedRoute><TemplateEditor /></ProtectedRoute>,
  },
  {
    path: 'meetings/templates/:templateId/edit',
    element: <ProtectedRoute><TemplateEditor /></ProtectedRoute>,
  },
  {
    path: 'meetings/instances/:instanceId',
    element: <ProtectedRoute><MeetingInProgressPage /></ProtectedRoute>,
  },
  {
    path: 'meetings/instances/:instanceId/history',
    element: <ProtectedRoute><MeetingHistoryDetail /></ProtectedRoute>,
  },
  {
    path: 'action-items',
    element: <ProtectedRoute><ActionItemsPage /></ProtectedRoute>,
  },
  {
    path: 'decisions',
    element: <ProtectedRoute><DecisionsPage /></ProtectedRoute>,
  },
  {
    path: 'announcements',
    element: <ProtectedRoute><AnnouncementsPlaceholder /></ProtectedRoute>,
  },
  {
    path: 'vto',
    element: <ProtectedRoute><VtoPage /></ProtectedRoute>,
  },
  {
    path: 'accountability',
    element: <ProtectedRoute><AccountabilityPage /></ProtectedRoute>,
  },
  {
    path: '*',
    element: <Navigate to="/huddle" replace />,
  },
];
